<template>
  <div id="appRoot">
    <template v-if="$route.meta.public === true">
      <v-app>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </v-app>
    </template>
    <template v-else-if="$route.meta.webexMeeting === true">
      <v-app>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </v-app>
    </template>
    <template v-else-if="$route.meta.webexAdminMeeting === true">
      <v-app>
        <admin-header class="app--toolbar"></admin-header>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
        <left-side></left-side>
      </v-app>
    </template>
    <template v-else-if="$route.meta.frame === true">
      <krx-left-side></krx-left-side>
    </template>
    <template v-else-if="$route.meta.frameBody === true">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </template>
    <template v-else>
      <div class="krx-container">
        <!-- <krx-lnb></krx-lnb>-->
        <div style="display: flex; flex-direction: row; height: 100%">
          <v-app></v-app>
          <krx-left-side v-if="$route.meta.webexMeeting === false"></krx-left-side>
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </div>
    </template>
    <v-snackbar
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      <v-icon dark>check_circle</v-icon>
      &nbsp;&nbsp;{{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import AdminHeader from '@/components/AdminHeader';
import RightSide from '@/components/home/RightSide';
import LeftSide from '@/components/home/LeftSide';
import KrxLnb from '@/components/krx/KrxLnb';
import KrxLeftSide from '@/components/krx/KrxLeftSide';
import TestKrxLeftSide from '@/components/krx/TestKrxLeftSide';
import AppFab from '@/components/AppFab';
import PageHeader from '@/components/PageHeader';
import menu from '@/api/menu';
import ThemeSettings from '@/components/ThemeSettings';
import AppEvents from './event';
import { mapState } from 'vuex';

export default {
  components: {
    AppDrawer,
    AppToolbar,
    AdminHeader,
    AppFab,
    PageHeader,
    ThemeSettings,
    KrxLeftSide,
    KrxLnb,
    LeftSide,
    RightSide,
    TestKrxLeftSide,
    // HomeAppBar: () => import('@/components/home/AppBar'),
    // HomeFooter: () => import('@/components/home/Footer'),
  },
  data: () => ({
    expanded: true,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: '',
      color: '',
    },
  }),
  computed: {
    ...mapState(['isUserLoggedIn', 'isWebexLoginMode']),
  },
  created() {
    AppEvents.forEach((item) => {
      this.$on(item.name, item.callback);
    });

    window.getApp = this;

    if (this.$store.state.locale) {
      this.$i18n.locale = this.$store.state.locale;
    }
  },
  methods: {
    openThemeSettings() {
      this.$vuetify.goTo(0);
      this.rightDrawer = !this.rightDrawer;
    },
  },
};
</script>

<style lang="stylus" scoped>
.setting-fab
  top:50%!important;
  right:0;
  border-radius:0
.page-wrapper
  min-height:calc(100vh - 64px - 50px - 51.5px);

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .2s;
}

.fade-enter-active {
  transition-delay: .2s;
}

.fade-enter, .fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue